import { WebRtcStatistics } from '@core/swagger-client';
import { curveBasis } from '@visx/curve';
import { useParentSize } from '@visx/responsive';
import { scaleLinear, scaleTime } from '@visx/scale';
import { LinePath } from '@visx/shape';

interface SparkLineProps extends React.SVGProps<SVGSVGElement> {
    data: WebRtcStatistics[];
    field: Exclude<keyof WebRtcStatistics, 'timestamp'>; // The field to visualize, excluding timestamp
}

export const SparkLine = ({ data, field, ...props }: SparkLineProps) => {

    const { parentRef, width, height } = useParentSize({ debounceTime: 150 });

    const maxValue = Math.max(...data.map((d) => d[field] as number));
    const minValue = Math.min(...data.map((d) => d[field] as number));

    const timeScale = scaleTime<number>({
        domain: [Math.min(...data.map((d) => new Date(d.timestamp).getTime())), Math.max(...data.map((d) => new Date(d.timestamp).getTime()))],
        range: [0, typeof width === 'number' ? width : parseFloat(width)]
    });
    const dataScale = scaleLinear<number>({
        domain: [minValue * 0.9, maxValue * 1.1],
        range: [typeof height === 'number' ? height : parseFloat(height), 0],
        nice: true
    });

    return (
        <div ref={parentRef} className="h-20">
            <svg className="border-b-1 border-gray-500" width={width} height={height} {...props}>
                <LinePath
                    data={data}
                    curve={curveBasis}
                    x={(d) => timeScale(new Date(d.timestamp)) ?? 0}
                    y={(d) => dataScale(d[field] as number) ?? 0}
                    stroke="#141e66"
                    strokeWidth={0.5}
                    width={width}
                    height={height}
                />
            </svg>
        </div>
    );
};
